import React, { useEffect, useRef, useState } from "react";
import {ChatIcon} from "./icons";

/**
 * Floating Start Chat button.
 *
 * @param {Object} props
 * @param {function} props.onClick Click handler
 * @returns {JSX.Element}
 */

let isResized = false;

export const StartChatButton = ({ onClick, hideTooltip = false }) => {
    const tooltipRef = useRef(null);
    const btnRef = useRef(null);
    const resizeTimeout = useRef(null);

    const [position, setPosition] = useState("bottom"); // DEFAULT

    const updatePosition = () => {
        if (!tooltipRef.current || hideTooltip) return;

        const rect = tooltipRef.current.getBoundingClientRect();
        let newPos = "bottom";

        if (rect.bottom > window.innerHeight - 8) newPos = "top";
        else if (rect.right > window.innerWidth - 8) newPos = "left";
        else if (rect.left < 8) newPos = "right";

        setPosition(prev => (prev !== newPos ? newPos : prev));
    };

    useEffect(() => {
        if (hideTooltip) return;

        setPosition("bottom");

        requestAnimationFrame(() => {
            setTimeout(() => {
                updatePosition();
            }, 0);
        });

        const handleResize = () => {
            clearTimeout(resizeTimeout.current);
            resizeTimeout.current = setTimeout(updatePosition, 120);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            clearTimeout(resizeTimeout.current);
            window.removeEventListener("resize", handleResize);
        };
    }, [hideTooltip]);

    if(isResized != true) {
        isResized = true;
        setTimeout(function (){
            window.dispatchEvent(new Event("resize"));
        }, 1000)
    }

    return (
        <button ref={btnRef} className={`btn sb-start-chat-btn ${hideTooltip ? "no-tooltip" : ""}`} onClick={onClick} type="button">
            <ChatIcon />
            {!hideTooltip && (
                <span ref={tooltipRef} className={`sb-start-chat-btn_txt pos-${position}`}>
                    <ChatIcon />
                    <b>Try to book with AI</b>
                </span>
            )}
        </button>
    );
};